import { KEY_OFFICES } from "./keyOffices";

export const ADMIN_MODULES = [
  { key: "programs", path: "/programs", label: "Programs" },
  { key: "employee", path: "/employee", label: "Employees" },
  { key: "faculties", path: "/faculties", label: "Faculties" },
  { key: "departments", path: "/departments", label: "Departments" },
  { key: "campus-facilities", path: "/campus-facilities", label: "Campus Facilities" },
  { key: "career", path: "/career", label: "Career" },
  { key: "career-applicants", path: "/career/applicants", label: "Applicant Lists" },
  { key: "slider", path: "/slider", label: "Slider" },
  { key: "home-page", path: "/home-page", label: "Home Page" },
  { key: "university-life", path: "/university-life", label: "University Life" },
  { key: "updates", path: "/updates", label: "Updates" },
  {
    key: "announcements-group",
    label: "Announcements",
    /** One permission covers every office under this group. */
    permissionKey: "announcements",
    children: KEY_OFFICES.map((office) => ({
      key: "announcements",
      path: `/announcements/${office.slug}`,
      label: office.label,
    })),
  },
  {
    key: "sdc-group",
    label: "Skills Development",
    children: [
      { key: "sdc-batches", path: "/sdc/batches", label: "Batches" },
      { key: "sdc-programs", path: "/sdc/programs", label: "Programs" },
      { key: "sdc-courses", path: "/sdc/courses", label: "Courses" },
    ],
  },
  {
    key: "offices-group",
    label: "Offices",
    children: [
      { key: "offices", path: "/offices", label: "Key Offices" },
      {
        key: "registrar-team",
        path: "/registrar-team",
        label: "Team of Registrar",
      },
      {
        key: "it-services",
        path: "/it-services",
        label: "IT Services",
      },
      {
        key: "publication-submissions",
        path: "/publication-submissions",
        label: "Publication Submissions",
      },
    ],
  },
  { key: "researches", path: "/researches", label: "Researches" },
  { key: "resources", path: "/resources", label: "Resources" },
  { key: "admissionAds", path: "/admissionAds", label: "AdmissionAds" },
  { key: "tenders", path: "/tender", label: "Tenders" },
  { key: "generic-ads", path: "/generic-ad", label: "Generic Ads" },
  { key: "qec", path: "/qec", label: "QEC" },
  { key: "popup-modal", path: "/popup-modal", label: "Popup Modal" },
  { key: "contact", path: "/contact-messages", label: "Contact Messages" },
  { key: "contact-phones", path: "/contact-phones", label: "Contact Phones" },
  { key: "top-bar", path: "/top-bar", label: "Top Bar" },
];

/** Flat list of permission/module keys (excludes group parents; dedupes shared keys). */
export const flattenAdminModules = (modules = ADMIN_MODULES) => {
  const out = [];
  const seen = new Set();
  modules.forEach((mod) => {
    if (Array.isArray(mod.children) && mod.children.length) {
      if (mod.permissionKey) {
        if (!seen.has(mod.permissionKey)) {
          seen.add(mod.permissionKey);
          out.push({
            key: mod.permissionKey,
            path: mod.children[0]?.path,
            label: mod.label,
          });
        }
        return;
      }
      mod.children.forEach((child) => {
        if (seen.has(child.key)) return;
        seen.add(child.key);
        out.push(child);
      });
    } else if (mod.path && mod.key) {
      if (seen.has(mod.key)) return;
      seen.add(mod.key);
      out.push(mod);
    }
  });
  return out;
};

export const isSuperAdminUser = (user) =>
  !!user &&
  (user.role === "superadmin" ||
    user.canManageUsers === true ||
    user.email === "humail181153@gmail.com");

export const canAccessModule = (user, moduleKey) => {
  // Until profile loads (or legacy session), allow modules so the panel stays usable
  if (!user) return true;
  if (user.role === "superadmin" || user.role === "admin" || isSuperAdminUser(user)) return true;
  if (!Array.isArray(user.permissions)) return false;
  if (
    moduleKey === "campus-facilities" &&
    (user.permissions.includes("campus-facilities") ||
      user.permissions.includes("facilities"))
  ) {
    return true;
  }
  if (
    moduleKey === "home-page" &&
    (user.permissions.includes("home-page") ||
      user.permissions.includes("home-settings") ||
      user.permissions.includes("home_page"))
  ) {
    return true;
  }
  if (
    moduleKey === "university-life" &&
    (user.permissions.includes("university-life") ||
      user.permissions.includes("cms-pages"))
  ) {
    return true;
  }
  if (
    moduleKey === "career-applicants" &&
    (user.permissions.includes("career-applicants") ||
      user.permissions.includes("career"))
  ) {
    return true;
  }
  return user.permissions.includes(moduleKey);
};

export const getDefaultRoute = (user) => {
  if (!user) return "/programs";
  if (isSuperAdminUser(user) || user.role === "admin") {
    return "/programs";
  }
  const first = flattenAdminModules().find((m) => canAccessModule(user, m.key));
  return first?.path || "/programs";
};
